import React from "react";
export default () => (React.createElement("section", { className: "page-section" },
    React.createElement("div", { "data-ecom-spinner": "center" },
        React.createElement("div", { className: "spinner" }))));
